var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinked = function SvgLinked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2DA0FC",
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M3.119 7.307c-.39 0-.699.3-.699.678 0 .387.31.696.699.696h6.659v1.18c0 .608.592.828 1.079.458l2.467-1.85a.57.57 0 0 0 0-.933l-2.467-1.86c-.469-.351-1.08-.167-1.08.459v1.172z",
    clipRule: "evenodd"
  })));
};
export default SvgLinked;